import { render, staticRenderFns } from "./NewItemCategory.vue?vue&type=template&id=1356b30f&"
import script from "./NewItemCategory.vue?vue&type=script&lang=js&"
export * from "./NewItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewItemCategory.vue?vue&type=style&index=0&id=1356b30f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports